<template>
  <div class="form-group form-group--checkbox-single" v-bind:class="getClass()">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   v-bind:name="component.key"
                   v-bind:disabled="disabledHandler()"
                   v-validate="setRules()"
                   v-bind:data-vv-name="component.key"
                   v-on:focus="focusHandler()"
                   v-on:blur="blurHandler()"
                   v-model="component.data.currentValue"
                   v-bind:checked="component.data.currentValue">
            <span class="checkbox--text" v-html="component.data.textValue"></span>
          </label>
        </div>
      </div>
    </div>
    <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
        <g id="form_icon_error_alert" transform="translate(-252 -635)">
          <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
          <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
        </g>
      </svg>
      {{ (errors.first(component.key)) }}</span>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-checkbox-single',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false
    }
  },
  created () {
    this.setValue()
  }
}
</script>
